/**
 * Normaliza un texto removiendo acentos, caracteres especiales y convirtiéndolo a minúsculas.
 */
export function normalizeText(text?: string): string {
  if (!text) return "";
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

/**
 * Determina de forma precisa si un nombre de categoría corresponde a una Bebida.
 */
export function isDrinkCategory(categoryName?: string): boolean {
  if (!categoryName) return false;
  const norm = normalizeText(categoryName);
  if (!norm) return false;

  // Usar límites de palabra (\b) y palabras clave exclusivas de categorías de bebidas
  const drinkRegex = /\b(bebida|bebidas|gaseosa|gaseosas|jugo|jugos|refresco|refrescos|soda|sodas|cerveza|cervezas|agua|aguas|licor|licores|coctel|cocteles|cocktail|cocktails|malteada|malteadas|smoothie|smoothies|batido|batidos|limonada|limonadas|energizante|energizantes|hidratante|hidratantes|postobon|coca\s*cola|pepsi|vino|vinos|trago|tragos|frappe|frappes|naranjada|granizado|granizados)\b/i;

  return drinkRegex.test(norm);
}
